module.exports = __webpack_public_path__ + "img/404@2x.346a0eb3.png";